import { SignupData } from '../types';

const userHasValidReferralCode = (signupData: Partial<SignupData>) =>
  !!signupData.discountCodes?.find(code => code.isReferral && code.isSelected);

export default userHasValidReferralCode;
